import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Stack,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import RefundIcon from '@mui/icons-material/ReplayCircleFilledOutlined';
import AnalyticsIcon from '@mui/icons-material/Analytics';

// Tab Panel Component
export const TabPanel = ({ children, value, index }) => {
  return value === index && <Box sx={{ p: 3 }}>{children}</Box>;
};

// Overview Tab Content
const OverviewTab = () => {
  return (
    <Box display="flex" gap={4} p={3} flexWrap="wrap">
      {/* Left - Recent Activity */}
      <Card
        sx={{
          flex: 1,
          minWidth: 300,
          backgroundColor: '#ffffffff',
        }}
      >
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Recent Activity
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Latest actions in your system
          </Typography>
          <List>
            <ListItem disablePadding sx={{ mb: 1 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ color: 'green', fontSize: 12 }} />
              </ListItemIcon>
              <ListItemText
                primary="New user registered"
                secondary="2 minutes ago"
              />
            </ListItem>
            <ListItem disablePadding sx={{ mb: 1 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ color: 'blue', fontSize: 12 }} />
              </ListItemIcon>
              <ListItemText
                primary="Order #ORD-005 placed"
                secondary="5 minutes ago"
              />
            </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ color: 'orange', fontSize: 12 }} />
              </ListItemIcon>
              <ListItemText
                primary="Refund request submitted"
                secondary="10 minutes ago"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>

      {/* Right - Quick Actions */}
      <Card
        sx={{
          flex: 1,
          minWidth: 300,
          backgroundColor: '#ffffff',
        }}
      >
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Quick Actions
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Common administrative tasks
          </Typography>

          <Stack spacing={1.5} mt={2} ml={9} mr={9}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              startIcon={<PersonAddIcon />}
            >
              Add New User
            </Button>
            <Button fullWidth variant="outlined" startIcon={<ShoppingCartIcon />}>
              Process Orders
            </Button>
            <Button fullWidth variant="outlined" startIcon={<RefundIcon />}>
              Review Refunds
            </Button>
            <Button fullWidth variant="outlined" startIcon={<AnalyticsIcon />}>
              View Analytics
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OverviewTab;
